var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgPhoneAlt(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M9.747 12.938c.75-.329 1.64-.141 2.156.515l1.594 1.922a14.566 14.566 0 005.203-5.203l-1.922-1.594c-.656-.515-.843-1.406-.515-2.156l2.25-5.25a1.842 1.842 0 012.11-1.125l5.25 1.125c.843.187 1.5.984 1.5 1.828 0 10.875-8.25 19.781-18.798 20.906-.422.047-.89.094-1.36.094-.28 0-.562.047-.89.047-.844 0-1.64-.656-1.828-1.5l-1.125-5.25a1.842 1.842 0 011.125-2.11l5.25-2.25zM6.653 21.75c10.125-.14 18.282-8.297 18.47-18.422l-4.688-.984-2.016 4.687 1.688 1.36a2.294 2.294 0 01.515 2.906 16.729 16.729 0 01-6 6 2.294 2.294 0 01-2.906-.516l-1.36-1.687-4.687 2.015.984 4.641z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgPhoneAlt);
export default ForwardRef;
